// Sound on or off, and how loud, for this phone (FE-24).
import { useEffect, useState } from 'react';
import { onSound, setSound, setVolume, soundOn, type Volume, volume } from '../lib/sound';
import { S } from '../strings';

export function SoundToggle() {
  const [on, setOn] = useState(soundOn);
  useEffect(() => onSound(setOn), []);
  return (
    <button type="button" className={`chip${on ? ' is-on' : ''}`} aria-pressed={on} onClick={() => setSound(!on)}>
      {on ? S.sound.on : S.sound.off}
    </button>
  );
}

/** The menu sheet's volume row (only while sound is on). */
export function VolumeRow() {
  const [on, setOn] = useState(soundOn);
  const [v, setV] = useState(volume);
  useEffect(
    () =>
      onSound((o) => {
        setOn(o);
        setV(volume());
      }),
    [],
  );
  if (!on) return null;
  return (
    <li className="sheet__row">
      <span>{S.sound.volume}</span>
      <span className="row">
        {(['low', 'normal', 'loud'] as Volume[]).map((k) => (
          <button
            key={k}
            type="button"
            className={`chip${v === k ? ' is-on' : ''}`}
            aria-pressed={v === k}
            onClick={() => setVolume(k)}
          >
            {S.sound.volumes[k]}
          </button>
        ))}
      </span>
    </li>
  );
}
